module.exports = {
  videophotography: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Video & Photography",
    "description": `Δημιουργούμε εταιρικά video που να ανταποκρίνεται πλήρως στην εικόνα και τις αξίες της εταιρείας σας. Διαθέτουμε εξειδικευμένο προσωπικό σε όλο το φάσμα της παραγωγής με πολύχρονη εμπειρία. Στο pre-production στάδιο, σχεδιάζουμε το ύφος και τη δομή του video. Με γνώμονα την αισθητική και τους στόχους σας, το δημιουργικό μας τμήμα καταρτίζει το story board (storytelling, animation ή φυσικά πρόσωπα, casting), και σας το παρουσιάζουμε προς έγκριση.
    Ακολουθεί το στάδιο της παραγωγής όπου πραγματοποιούνται τα γυρίσματα ή οι συνθέσεις των εικόνων (σε περίπτωση που δεν απαιτούνται γυρίσματα). Στο post production στάδιο, οι έμπειροι μοντέρ μας κάνουν τις τελευταίες πινελιές (χρωματικές διορθώσεις, προσθήκη εφέ και γραφικών, μιξάζ ήχου) και μεταγράφουν το εταιρικό video στα κατάλληλα μέσα για τη διανομή του.
    Επιλέξτε τη Think Plus για την παραγωγή του εταιρικού σας video και αποκτήστε ένα δυναμικό εργαλείο προβολής!`,
    "serviceType": "Video & Photography",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "Video & Photography | Think Plus - Advertising"
  },
  onlinemarketing: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Online Marketing",
    "description": `Social Media Strategy Facebook, Twitter, Pinterrest ή Instagram?
    Ή μήπως όλα?
    Ακόμη αναρωτιέστε ποιά θα είναι η παρουσία σας στα social media?
    Ξεχάστε τα Facebook Page με ανύπαρκτο περιεχόμενο και τους λογαριασμούς Twitter με στερεότυπα τιτιβίσματα, και ελάτε σε μας να στήσουμε μία ολοκληρωμένη στρατηγική για social media που να ταιριάζει στο εταιρικό σας προφίλ. Στη Think Plus αναγνωρίζουμε τις ξεχωριστές σας ανάγκες για προβολή στα κοινωνικά μέσα δικτύωσης. Επιλέγουμε τα κατάλληλα Social Media για εσάς, που θα αυξήσουν την αλληλεπίδραση σας με το κοινό. Σχεδιάζουμε πρωτότυπες online marketing εκστρατείες που φέρνουν Likes, Followers και το μέγιστο δυνατό engagement!`,
    "serviceType": "Online Marketing",
    "offers": {
      "@type": "offer",
      "Price": "Από 100",
      "priceCurrency": "EUR"
    },
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "Online Marketing",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "Online Marketing | Think Plus - Advertising"
  },
  designart: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Design & Art",
    "description": `Εταιρική Ταυτότητα.
    Η εταιρική ταυτότητα αποτελεί την πρώτη εικόνα της εταιρείας σας στο κοινό και τους συνεργάτες σας. Εμείς στη Think Plus σχεδιάζουμε την εταιρική σας ταυτότητα με γνώμονα τη μοναδικότητα, τις απαιτήσεις και το επίπεδο της επιχείρησης σας. Οι έμπειροι designers μας σχεδιάζουν για σας το λογότυπο ή το σήμα της εταιρείας ενώ οι copywriters δημιουργούν το σλόγκαν που θα το συνοδεύει.
    Επιλέξτε τη Think Plus για το design της εταιρικής σας ταυτότητας και κερδίστε αναγνωρισιμότητα και ισχυρές δυνατότητες επικοινωνίας.`,
    "serviceType": "Design & Art",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "Design & Art",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "Design & Art | Think Plus - Advertising"
  },
  webdesign: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "ΚΑΤΑΣΚΕΥΗ ΙΣΤΟΣΕΛΙΔΩΝ",
    "description": `ΚΑΤΑΣΚΕΥΗ ΙΣΤΟΣΕΛΙΔΩΝ
    Κατασκευή ιστοσελίδων αλλά θέλω και ισχυρή παρουσία στην Google
    Εμείς στη Think Plus έχουμε το know-how για το σχεδιασμό και την κατασκευή ιστοσελίδων. Επιβλητικό design, πρωτότυπο copywriting και δυνατό SEO αποτελούν τα κύρια χαρακτηριστικά του νέου σας site με την Think Plus.
    Αναλαμβάνουμε την κατασκευή μοντέρνων ιστοσελίδων με ηχηρή παρουσία στις μηχανές αναζήτησης. Τη στιγμη που οι οθονες ’ξεχειλώνουν’, το mouse μπαίνει στο συρτάρι και τα tablets έχουν γίνει το πιο must-have gadget, εσείς αφήνετε την ιστοσελίδα σας να αιωρείται στο παρελθόν;`,
    "serviceType": "ΚΑΤΑΣΚΕΥΗ ΙΣΤΟΣΕΛΙΔΩΝ",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "ΚΑΤΑΣΚΕΥΗ ΙΣΤΟΣΕΛΙΔΩΝ",
    "isRelatedTo": "Online Marketing",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "Web Design | Think Plus - Advertising"
  },
  shopify: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Shopify κατασκευή eShop",
    "description": "H Λύση σας στο eCommerce | Πλήρες & Λειτουργικό Σύστημα E-Shop με Shopify.",
    "serviceType": "Shopify κατασκευή eShop",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "Shopify κατασκευή eShop",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "Shopify Eshop | Think Plus - Advertising"
  },
  wordpress: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "WordPress Development",
    "description": "WordPress - Σχεδιασμός ιστοσελίδας με σύγχρονη αισθητική και λειτουργικότητα φιλική προς τις φορητές συσκευές. Ιδιαίτερη βαρύτητα θα δοθεί στην ευχρηστία και την ταχύτητα απεικόνισης του περιεχομένου.",
    "serviceType": "WordPress Development",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "WordPress Development",
    "isRelatedTo": "Online Marketing",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "WordPress Development | Think Plus - Advertising"
  },
  videography: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Videography",
    "description": "THINK PLUS + VIDEOGRAPHY | 1 λεπτό video = 1,8 εκατ. λέξεις",
    "serviceType": "Videography",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "Videography",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "Video Productions | Think Plus - Advertising"
  },
  photography: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "PHOTOGRAPHY",
    "description": "Η δύναμη της επαγγελματικής φωτογράφισης ισχυροποιεί το brand σας σε όλα τα μέσα",
    "serviceType": "PHOTOGRAPHY",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "PHOTOGRAPHY",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "PRODUCT PHOTOGRAPHY | Think Plus - Advertising"
  },
  abovetheline: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Above the Line",
    "description": "How well we communicate is determined not by how well we say things, but how well we are understood.",
    "serviceType": "above the line",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "Above the Line",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "Above the Line | Think Plus - Advertising"
  },
  belowtheline: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Below the Line",
    "description": "Connecting Online Behaviors with Offline Transactions.",
    "serviceType": "Below the line",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "Below the Line",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "Below the Line | Think Plus - Advertising"
  },
  mailchimpexperts: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "MAILCHIMP CERTIFIED EXPERTS",
    "description": "Το Mailchimp είναι ένα από τα μεγαλύτερα εργαλεία για το σχεδιασμό και την αποστολή εντυπωσιακών μηνυμάτων ηλεκτρονικού ταχυδρομείου, τη διαχείριση των συνδρομητών σας και την παρακολούθηση της απόδοσης της καμπάνιας. Ως πιστοποιημένοι mailchimp experts, προσφέρουμε προσαρμοσμένες λύσεις για την κάλυψη των δικών σας επιχειρηματικών αναγκών.",
    "serviceType": "MAILCHIMP CERTIFIED EXPERTS",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "MAILCHIMP CERTIFIED EXPERTS",
    "isRelatedTo": "Online Marketing",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "Mailchimp Marketing | Think Plus - Advertising"
  },
  socialMediaMarketing: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Social Media Marketing",
    "description": `Στην Think Plus παρέχουμε υπηρεσίες Social Media Marketing με γνώμονα τις δικές σας ανάγκες. Διαχείριση Social Media & Λύσεις για τη δική σας επιχείρηση.`,
    "serviceType": "Social Media Marketing",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "Social Media Marketing",
    "isRelatedTo": "Online Marketing",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "Social Media Marketing | Think Plus - Advertising"
  },
  digitalMarketing: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Digital Marketing | Υπηρεσίες",
    "description": "Γιατί καμιά επιχείρηση δεν μπορεί να μην είναι στο internet",
    "serviceType": "Digital Marketing",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "Digital Marketing",
    "isRelatedTo": "Online Marketing",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "Digital Marketing | Think Plus - Advertising"
  },
  contentMarketing: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Content Marketing",
    "description": "Η πιο συνηθισμένη ερώτηση που κάνει ένας επιχειρηματίας είναι ‘πως θα βρω τον επόμενο πελάτη μου’. Η αμέσως επόμενη είναι ‘πως θα με βρουν οι υποψήφιοι πελάτες’. Υπάρχουν πολλές απαντήσεις σε αυτό το ερώτημα αλλά η πιο συνηθισμένη απάντηση είναι το Content Marketing.",
    "serviceType": "Content Marketing",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "Digital Marketing",
    "isRelatedTo": "Online Marketing",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "Content Marketing  | Think Plus - Advertising"
  },
  seo: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "SEO [search engine optimization]",
    "description": "Το SEO έχει αρκετά πλεονεκτήματα για κάθε επιχείρηση που θέλει ένα σωστό marketing mix. Το SEO έχει θετική επίδραση στην εμπειρία του επισκέπτη επειδή προσφέρει την κατάλληλη πληροφορία, οπτικοακουστικό υλικό, ευκολία πλοήγησης, και σωστή εμπειρία στις κινητές συσκευές. ",
    "serviceType": "SEO [search engine optimization]",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "Digital Marketing",
    "isRelatedTo": "Online Marketing",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "SEO [search engine optimization]  | Think Plus - Advertising"
  },
  ppc: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "PPC [Pay Per Click]",
    "description": "Η πιο δημοφιλής μέθοδος διαφήμισης στην ψηφιακή σφαίρα.",
    "serviceType": "PPC",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "Digital Marketing",
    "isRelatedTo": "Online Marketing",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "PPC  | Think Plus - Advertising"
  },
  emailMarketing: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Email Marketing",
    "description": "Το Email Marketing είναι η πιο οικονομική λύση για επιχειρήσεις που θέλουν να διατηρούν επαφή με τους πελάτες τους σε τακτά χρονικά διαστήματα.",
    "serviceType": "Email Marketing",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "Digital Marketing",
    "isRelatedTo": "Online Marketing",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "Email Marketing  | Think Plus - Advertising"
  },
  messagingMarketing: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Instant Messaging Marketing",
    "description": "Το πλεονέκτημα στο Marketing",
    "serviceType": "Instant Messaging Marketing",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "Digital Marketing",
    "isRelatedTo": "Online Marketing",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "Instant Messaging Marketing  | Think Plus - Advertising"
  },
  influencerMarketing: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Influencer Marketing",
    "description": "Γίνε διάσημος μέσω των διάσημων",
    "serviceType": "Influencer Marketing",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "Digital Marketing",
    "isRelatedTo": "Online Marketing",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "Influencer Marketing | Think Plus - Advertising"
  },
  mobileMarketing: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Mobile Marketing",
    "description": "Το 40% των ηλεκτρονικών συναλλαγών γίνεται μέσω κινητών συσκευών",
    "serviceType": "Mobile Marketing",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "Digital Marketing",
    "isRelatedTo": "Online Marketing",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "Mobile Marketing | Think Plus - Advertising"
  },
  videoMarketing: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Video Marketing",
    "description": "Το μέλλον του marketing είναι Video",
    "serviceType": "Video Marketing",
    "areaServed": "Ελλάδα",
    "brand": "Think Plus - Advertising",
    "category": "Digital Marketing",
    "isRelatedTo": "Online Marketing",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "Video Marketing | Think Plus - Advertising"
  },
  googleads: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Google Ads PPC Management",
    "description": "Γνωρίζατε ότι κατά μέσο όρο οι επιχειρήσεις πραγματοποιούν κέρδη 3€ για κάθε 1,60€ που δαπανώνται στο AdWords",
    "serviceType": "Google Ads PPC Management",
    "areaServed": "Ελλαδα",
    "brand": "Think Plus - Advertising",
    "category": "Digital Marketing",
    "isRelatedTo": "Online Marketing",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "Google Ads | Think Plus - Advertising"
  },
  facebookads: {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": "Facebook Ads Management",
    "description": "Σχεδόν το 80% των χρηστών του Διαδικτύου χρησιμοποιούν το Facebook είτε για προσωπική τους χρήση είτε ως διαφημιστική πλατφόρμα",
    "serviceType": "Facebook Ads Management",
    "areaServed": "Ελλαδα",
    "brand": "Think Plus - Advertising",
    "category": "Digital Marketing",
    "isRelatedTo": "Online Marketing",
    "logo": "https://think-plus.gr/images/tp-logoblack.svg",
    "provider": "Think Plus - Advertising",
    "alternateName": "Facebook Ads | Think Plus - Advertising"
  }
}